import { render, staticRenderFns } from "./u-video.vue?vue&type=template&id=73ec3bd2&scoped=true"
import script from "./u-video.vue?vue&type=script&lang=js"
export * from "./u-video.vue?vue&type=script&lang=js"
import style0 from "./u-video.vue?vue&type=style&index=0&id=73ec3bd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ec3bd2",
  null
  
)

export default component.exports